module.exports = __webpack_public_path__ + "img/plus.30e6c92e.svg";